import Stack from '@mui/material/Stack'
import { ModalExpSelect } from '../../modal-exp-select.component'
import { ExternalLabel } from '../../UInput.component'
import { getFieldTestId } from '../field-helpers'
import type { FieldRenderer } from '../types'

const MONTHS = Array.from({ length: 12 }, (_, i) => String(i + 1).padStart(2, '0'))
const currentYear = new Date().getFullYear()
const YEARS = Array.from({ length: 12 }, (_, i) => String(currentYear + i))

// Parses stored value "MM/YY" → { month, year: "20YY" }
const parseExpiry = (value: string) => {
    const [month = '', year = ''] = (value as string).split('/')
    return { month, year: year ? `20${year}` : '' }
}

const renderExpDateField: FieldRenderer = ({ field, ctx, t }) => {
    const key = field.key
    const stored = (ctx.form[key] as string) ?? ''
    return (
        <Stack key={key}>
            <ExternalLabel>{t(field.label)}</ExternalLabel>
            <ModalExpSelect
                value={parseExpiry(stored)}
                options={{ month: MONTHS, year: YEARS }}
                onSet={(month, year) =>
                    ctx.setForm((prev: Record<string, unknown>) => ({
                        ...prev,
                        [key]: `${month}/${year.slice(2)}`
                    }))
                }
                disabled={ctx.formDisabled}
                inputTestId={getFieldTestId(ctx, key, 'input')}
                data-testid={getFieldTestId(ctx, key, 'modal-exp-select')}
            />
        </Stack>
    )
}

export default renderExpDateField
